import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CookieHelperService {
  public setCookie(
    name: string,
    value: string,
    options: { path?: string; 'max-age'?: number; domain?: string } = {
      path: '/',
      'max-age': 31536000,
    }
  ) {
    let updatedCookie =
      encodeURIComponent(name) + '=' + encodeURIComponent(value);

    Object.keys(options).forEach((key) => {
      updatedCookie += '; ' + key;
      const optionValue = options[key];
      if (optionValue !== true) {
        updatedCookie += '=' + optionValue;
      }
    });

    document.cookie = updatedCookie;
  }
}
